import { Spinner } from '@tallink/components-lib'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'

import { getSummary } from '../../selectors/selectors'
import s from './LoadingPrice.module.scss'

export default function LoadingPrice({ price }) {
  const { loading } = useSelector(getSummary)

  return loading ? (
    <div className={s.spinner}>
      <Spinner />
    </div>
  ) : (
    <div className={s['price-value']}>{price} €</div>
  )
}

LoadingPrice.propTypes = {
  price: PropTypes.number.isRequired
}
